import { useState, useRef, useEffect } from 'react';
import { removePortalRoot, createPortalRoot } from '../utils/portalRoot.js';

// This hook is used for creating a portalRoot
// isVisible - may be used for detecting start/end events for transition effects
const useGetPortalRoot = (isOpen, portalId) => {
    const [portalRoot, setPortalRoot] = useState(null);
    const [isVisible, isIsVisible] = useState(false);
    const timeoutRef = useRef(null);
    useEffect(() => {
        if (isOpen) {
            clearTimeout(timeoutRef.current);
            removePortalRoot(portalId);
            const portalRootElement = createPortalRoot(portalId);
            setPortalRoot(portalRootElement);
        }
        else {
            isIsVisible(false);
            timeoutRef.current = setTimeout(() => {
                removePortalRoot(portalId);
                setPortalRoot(null);
            }, 300);
        }
    }, [isOpen]);
    useEffect(() => {
        if (!portalRoot)
            return;
        isIsVisible(true);
    }, [portalRoot]);
    useEffect(() => () => removePortalRoot(portalId), []);
    return [portalRoot, isVisible];
};

export { useGetPortalRoot as default };
//# sourceMappingURL=useGetPortalRoot.js.map
